var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 0.166672C2.77984 0.166672 0.166504 2.78001 0.166504 6.00001C0.166504 9.22001 2.77984 11.8333 5.99984 11.8333C9.21984 11.8333 11.8332 9.22001 11.8332 6.00001C11.8332 2.78001 9.21984 0.166672 5.99984 0.166672ZM5.99984 10.6667C3.4215 10.6667 1.33317 8.57834 1.33317 6.00001C1.33317 3.42167 3.4215 1.33334 5.99984 1.33334C8.57817 1.33334 10.6665 3.42167 10.6665 6.00001C10.6665 8.57834 8.57817 10.6667 5.99984 10.6667Z",
    fill: "#959AC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCircle);
export default __webpack_public_path__ + "static/media/empty-circle.f4e01fc6cf15e361751bc5e8c4064d14.svg";
export { ForwardRef as ReactComponent };